import React from 'react'
import ProfileCover from '../../components/ProfileCover'
import { TitleText } from '@paypalcorp/pp-react'

interface DescriptionProps {
  text: string
  creator: {
    creatorName: string
    profileImage: string
    givenName: string
    surname: string
  }
}

const Description = ({ text, creator }: DescriptionProps) => (
  <>
    <TitleText as="p" data-testid="descriptionText">
      &quot;{text}&quot;
    </TitleText>

    <ProfileCover creator={creator} />
  </>
)

export default Description
